import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  SmartPosti pakiautomaat

  <span style="color:#85c1dc;">**FI:**</span>
  Toimitus Postin pakettiautomaattiin

  <span style="color:#85c1dc;">**RU:**</span>
  Терминал SmartPosti
*/
/* @__NO_SIDE_EFFECTS__ */
const m1338 = msg(
  mf`SmartPosti pakiautomaat`,
  mf`Toimitus Postin pakettiautomaattiin`,
  mf`Терминал SmartPosti`,
)

export { m1338 as 'link.smartpost.alt' }